/* HeyBear · Contact postcard (Shopify contact form): topic-specific placeholder, order number field for
   "Order help", friendly validation, and the "Message sent!" card after Shopify posts the form. */
HB.section('contact', function (root) {
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var sec = root.matches('.ct-hero') ? root : $('.ct-hero'), pc = $('#pc'), done = $('#pcDone'), d = sec.dataset;
  if (!pc) return;
  pc.noValidate = true;
  var off = [], on = function (el, ev, fn) { el.addEventListener(ev, fn); off.push(function () { el.removeEventListener(ev, fn); }); };
  var ph = { order: d.phOrder, wholesale: d.phWholesale, press: d.phPress, hi: d.phHi };
  function sync() { var c = pc.querySelector('input[data-k]:checked'), t = c ? c.getAttribute('data-k') : 'hi'; $('#pcOrdWrap').hidden = t !== 'order'; $('#pcMsg').placeholder = ph[t] || ''; }
  $$('input[data-k]').forEach(function (i) { on(i, 'change', sync); }); sync();
  function showDone(name) {
    $('#pcDoneTxt').textContent = String(d.done || '').replace('[name]', name || '').replace(/,\s*!/, '!');
    pc.classList.add('sent'); done.classList.add('on'); pc.setAttribute('aria-hidden', 'true');
    setTimeout(function () { $('#pcAgain').focus({ preventScroll: true }); }, 900);
  }
  on(pc, 'submit', function (e) {
    var err = $('#pcErr'), v = function (id) { return $(id).value.trim(); };
    if (!v('#pcMsg')) { e.preventDefault(); err.textContent = d.errMsg; $('#pcMsg').focus(); return; }
    if (!v('#pcName')) { e.preventDefault(); err.textContent = d.errName; $('#pcName').focus(); return; }
    if (!HB.emailOk(v('#pcEmail'))) { e.preventDefault(); err.textContent = d.errEmail; $('#pcEmail').focus(); return; }
    err.textContent = '';
    try { sessionStorage.setItem('hbPcName', v('#pcName').split(' ')[0]); } catch (er) {}
  });
  on($('#pcAgain'), 'click', function () {
    pc.reset(); sync(); done.classList.remove('on'); pc.classList.remove('sent'); pc.removeAttribute('aria-hidden');
    setTimeout(function () { $('#pcMsg').focus(); }, 600);
  });
  /* Shopify reloads the page after sending (…?contact_posted=true#pc) */
  if (done.getAttribute('data-state') === 'ok') { var n = ''; try { n = sessionStorage.getItem('hbPcName') || ''; } catch (er) {} showDone(n); }
  return function () { off.forEach(function (fn) { fn(); }); };
});
